export default Object.freeze({
  FULLSCREEN: 'fullscreen',
  COMMON: 'common'
});